import React, {FC, useEffect, useState} from 'react'
import {Col, Row} from 'react-bootstrap'
import './agent.scss';
import CustomerList from './CustomerList'
import DateRangePickers from '../../sharedComponent/DateRangePickers/DateRangePickers';
import DonutPieChart from '../../sharedComponent/DonutPieChart/DonutPieChart';
import moment from 'moment'
import { GET_AGENT_DASHBOARD } from '../../../utils/GraphQLAPI';
import { useLazyQuery } from '@apollo/client';
import ConversionRateCard from '../../sharedComponent/RadialChart/ConversionRateCard'
import Breadcrumbs from '../../sharedComponent/Breadcrumbs/Breadcrumbs';

const AgentDashboard: FC = () => {
  const [tpvStatus, setTpvStatus] = useState<any>()
  const [conversionRate, setConversionRate] = useState<any>()
  const [filterOptions, setFilterOptions] = useState<any>({
    fromDate: new Date(
      moment(moment().subtract(29, 'days').toDate()).format('YYYY-MM-DD') + 'T00:00:00'
    ).toISOString(),
    toDate: new Date(
      moment(moment().toDate()).format('YYYY-MM-DD') + 'T23:59:00'
    ).toISOString(),
  })

  // Filter - Date Range
  const getdataFromDateFilter = (fromDate: any, toDate: any, objDays: any) => {
    setFilterOptions((prevOptions: any) => {
      return {...prevOptions, fromDate, toDate}
    })
  }

  // Dashboard Chart Data Fetch
  const [getSalesAdminDashboardData, {loading:reload}] = useLazyQuery(GET_AGENT_DASHBOARD, {
    fetchPolicy:'network-only',
    onCompleted: (data:any) => {
      setTpvStatus(data?.getAgentDashboard.tpvReports)
      setConversionRate(data?.getAgentDashboard.conversionRate)
    },
  })

  // Dashboard API Hit
  useEffect(()=>{
    getSalesAdminDashboardData({
      variables: {
        agentDashboardInput : filterOptions
      } 
    })
  }, [filterOptions])

  return (
    <>
     <div className='d-flex justify-content-between align-items-center'>
        <Breadcrumbs title='Dashboard' subTitle='Home - Dashboard' />

        <div className='d-flex w-40 justify-content-evenly align-items-center'>
          <div className='mx-2'>
            <DateRangePickers getdataFromDateFilter={getdataFromDateFilter} colors={'white'}/>
          </div>
        </div>
      </div>

      <Row>
        <Col md lg xl='6' mb-md-5 mb-xl-10>
          {/* Utility Card */}
          <DonutPieChart data={tpvStatus} heading="TPV Status" subheading="TPVs" reload={reload}/>
        </Col>
        <Col md lg xl='6' mb-md-5 mb-xl-10>
          {/* Conservation Rate */}
          <ConversionRateCard data={conversionRate} heading ="Conversion Rate" subheading="TPVs" reload={reload} top="80%" classname={'agent'}/>
        </Col>
      </Row>

      <CustomerList getSalesAdminDashboardData={getSalesAdminDashboardData}/>
    </>
    
  )
}

export {AgentDashboard}
